import { APP_INITIALIZER, NgModule } from '@angular/core';
import { AngularFireModule } from '@angular/fire';
import { BrowserModule } from '@angular/platform-browser';
import { AngularFireAuth, AngularFireAuthModule } from "@angular/fire/auth";
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { environment } from 'src/environments/environment';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { SignInComponent } from './components/onboarding/sign-in/sign-in.component';
import { ForgotPasswordComponent } from './components/onboarding/forgot-password/forgot-password.component';
import { VerifyEmailComponent } from './components/onboarding/verify-email/verify-email.component';
import { AuthService } from './services/auth.service';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatCardModule } from '@angular/material/card';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatDividerModule } from '@angular/material/divider';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatRadioModule } from '@angular/material/radio';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatTableModule } from '@angular/material/table';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatChipsModule  } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatBadgeModule } from '@angular/material/badge';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { DataService } from './services/data.service';
import { configurationFactory } from './shared/utils/configuration';
import { ServiceWorkerModule } from '@angular/service-worker';
import { RouterModule } from '@angular/router';
import { SignUpComponent } from './components/onboarding/sign-up/sign-up.component';
import { DatePipe } from '@angular/common';

import { CompressImageService } from './services/compress-image.service';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { AdminAccountComponent } from './common/admin-account/admin-account.component';
import { CreateNotificationComponent } from './common/create-notification/create-notification.component';
import { HomeComponent } from './common/home/home.component';
import { EventsTableComponent } from './shared/events-table/events-table.component';
import { FollowersTableComponent } from './shared/followers-table/followers-table.component';
import { EventsComponent } from './common/events/events.component';
import { InfluencersComponent } from './common/influencers/influencers.component';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';
import { BooleanPipe } from './pipes/boolean.pipe';
import { MatSortModule } from '@angular/material/sort';
import { FormattedPricePipe } from './pipes/formatted-price.pipe';
import { LOCALE_ID } from '@angular/core';
import { CalendarComponent } from './components/calendar/calendar.component';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { ModalDetailEventComponent } from './components/modal-detail-event/modal-detail-event.component';
import { AuthInterceptor } from './services/auth-interceptor';
import { EventFormComponent } from './shared/event-form/event-form.component';
import { PickerModule } from "@ctrl/ngx-emoji-mart";
import { ModalCreateEventComponent } from './components/modal-create-event/modal-create-event.component';
import { GiftFormComponent } from './shared/gift-form/gift-form.component';
import { GeminiService } from './services/gemini.service';
import { TermsAndConditionsComponent } from './components/terms-and-conditions/terms-and-conditions.component';
import { LinkTreeComponent } from './components/link-tree/link-tree.component';
import { CheckSafacoinsCodeComponent } from './components/check-safacoins-code/check-safacoins-code.component';
@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    SignInComponent,
    SignUpComponent,
    ForgotPasswordComponent,
    VerifyEmailComponent,
    AdminAccountComponent,
    CreateNotificationComponent,
    HomeComponent,
    EventsTableComponent,
    FollowersTableComponent,
    EventsComponent,
    InfluencersComponent,
    PrivacyPolicyComponent,
    BooleanPipe,
    FormattedPricePipe,
    CalendarComponent,
    ModalDetailEventComponent,
    EventFormComponent,
    ModalCreateEventComponent,
    GiftFormComponent,
    TermsAndConditionsComponent,
    LinkTreeComponent,
    CheckSafacoinsCodeComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,  
    AppRoutingModule,
    HttpClientModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAuthModule,
    AngularFireStorageModule,
    AngularFirestoreModule,
    MatInputModule,
    MatButtonModule,
    MatFormFieldModule,
    MatToolbarModule,
    MatIconModule,
    MatSidenavModule,
    MatDatepickerModule,
    MatMomentDateModule,
    MatListModule,
    MatCheckboxModule,
    PickerModule,
    MatRadioModule,
    MatBadgeModule,
    MatSnackBarModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatCardModule,
    MatDividerModule,
    MatBottomSheetModule,
    MatDialogModule,
    MatSlideToggleModule,
    MatSortModule,
    MatSelectModule,
    MatChipsModule,
    CalendarModule.forRoot({ provide: DateAdapter, useFactory: adapterFactory }),
    MatAutocompleteModule,
    MatTabsModule,
    MatTableModule,
    MatDatepickerModule,
    RouterModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the app is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    })
  ],
  providers: [
    AuthService, DataService, DatePipe, CompressImageService,GeminiService,
    {
      provide: APP_INITIALIZER,
      useFactory: configurationFactory,
      multi: true,
      deps: [AngularFireAuth, AuthService]
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
   { provide: LOCALE_ID, useValue: 'es' },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
